import { setSessionStorageItem } from '@revenuemarket/browser';
import { Button, typographyStyle } from '@revenuemarket/cds';
import NaverLogo from '@revenuemarket/cds/components/Icon/NaverLogo';
import { validateCallbackUrl } from '@revenuemarket/utils';

import { OAuthProviderType } from '~apis/auth/maybeSignInWithOAuth';
import { generateRandomState, getOauthRedirectUrl } from '~components/Auth/Signin/utils';
import { OAUTH_AUTH_DOMAIN } from '~constants/env';
import { css } from '~libs/emotion';

const NaverLoginButton = ({
  title,
  callbackUrl,
  onNaverOauthClick,
}: {
  title: string;
  callbackUrl?: string;
  onNaverOauthClick?: () => void;
}) => {
  const handleClick = () => {
    onNaverOauthClick?.();

    const redirectUri = getOauthRedirectUrl(OAuthProviderType.NAVER);
    const randomState = generateRandomState();

    // callbackUrl 검증: 상대경로만 허용
    if (callbackUrl && validateCallbackUrl(callbackUrl)) {
      setSessionStorageItem(`oauth_login_callback`, callbackUrl);
    }

    // finance.cloud 도메인에서는 OAUTH_AUTH_DOMAIN으로 먼저 이동
    if (typeof window !== 'undefined' && window.location.hostname.endsWith('.finance.cloud')) {
      const currentOrigin = window.location.origin;
      const encodedOrigin = encodeURIComponent(currentOrigin);
      window.location.href = `${OAUTH_AUTH_DOMAIN}/oauth/init?provider=naver&origin=${encodedOrigin}&state=${randomState}`;
      return;
    }

    // 기존 로직: clobe.ai 도메인은 직접 OAuth 제공자로 이동
    const NAVER_AUTH_URL =
      `https://nid.naver.com/oauth2.0/authorize?` +
      `response_type=code` +
      `&client_id=syo9L6RiDqqp7vPRcq8p` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&state=${encodeURIComponent(randomState)}`;

    window.location.href = NAVER_AUTH_URL;
  };

  return (
    <Button
      onClick={handleClick}
      buttonType="default"
      buttonSize="xlarge"
      style={{
        ...typographyStyle['16_500'],
      }}
      className={css`
        border-color: #03c75a;
        background-color: #03c75a;
        color: #ffffff;

        &:hover {
          border-color: #07b053;
          background-color: #07b053;
        }
      `}
      icon={<NaverLogo />}
    >
      {title}
    </Button>
  );
};

export default NaverLoginButton;
